import * as React from 'react';

function FeatherIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.44185 1.77468C7.20799 1.00854 8.2471 0.578125 9.33058 0.578125C10.4141 0.578125 11.4532 1.00854 12.2193 1.77468C12.9854 2.54081 13.4159 3.57992 13.4159 4.6634C13.4159 5.74668 12.9856 6.78559 12.2198 7.55169L12.2193 7.55213L10.6724 9.10366C10.6411 9.14463 10.6045 9.18133 10.5636 9.21274L8.28825 11.4949C8.17881 11.6046 8.03017 11.6663 7.87516 11.6663H3.15872L1.57931 13.2457C1.3515 13.4735 0.982156 13.4735 0.75435 13.2457C0.526545 13.0179 0.526545 12.6486 0.75435 12.4208L2.3335 10.8416V6.12465C2.3335 5.96994 2.39495 5.82157 2.50435 5.71218L6.44185 1.77468ZM9.9592 8.16658L11.3937 6.72779L11.3944 6.72718C11.9417 6.17983 12.2492 5.43747 12.2492 4.6634C12.2492 3.88934 11.9417 3.14698 11.3944 2.59963C10.847 2.05229 10.1046 1.74479 9.33058 1.74479C8.55652 1.74479 7.81415 2.05229 7.26681 2.59963L3.50016 6.36628V9.67496L8.92102 4.25411C9.14882 4.0263 9.51817 4.0263 9.74597 4.25411C9.97378 4.48191 9.97378 4.85126 9.74597 5.07906L6.65845 8.16658H9.9592ZM5.49179 9.33325H8.79598L7.63303 10.4997H4.32538L5.49179 9.33325Z"
        fill="black"
      />
    </svg>
  );
}

const MemoFeatherIcon = React.memo(FeatherIcon);
export default MemoFeatherIcon;
